// Whether this session can switch to another organization: the one decision
// behind every "switch organization" affordance -- the sidebar's organization
// card, the account menu's Change Organization and the learner landing's
// Switch organization (owner feedback 2026-10-07: no switch for someone with
// nowhere else to go).
//
// It is the token's multipleAccounts, which auth computes with the
// organization picker's (/auth/account) own rules on every sign-in, switch
// and refresh (rapid-api-auth common/auth hasMultipleAccounts): more than one
// organization the person can be in -- their live memberships, plus the
// scheduled organizations they own where the picker offers Restore (the
// admin, not impersonated). A pending, declined or revoked invite, a removed
// membership, a switched-off organization or a scheduled one they don't own
// is nowhere to switch to; a PIN session never switches. Read from the token,
// so it costs no request.
export const canSwitchOrganization = claims => !!(claims && claims.multipleAccounts)
